'use client'; // Esto asegura que el componente sea renderizado del lado del cliente

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import useUserStore from '@/store/zustand/decode-zustand';
import { jwtDecode } from 'jwt-decode';
import { hasPermission } from '@/utils/services/security';

const Root: React.FC = () => {  
  const router = useRouter(); // Hook de Next.js para manejar redirecciones en el cliente
  const token = useUserStore((state) => state.token);

  // Función para validar si el token está expirado
  const isTokenExpired = (token: string): boolean => {
    if (!token) return true;

    try {
      const decoded: { exp: number } = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Tiempo actual en segundos

      return decoded.exp < currentTime; // Devuelve true si el token está expirado
    } catch (error) {
      return true; // Si hay un error al decodificar el token, lo consideramos inválido
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isTokenExpired(token)) {
        router.push('/sign-in');
      } else {
        router.push('/dashboard');
      }
    };

    fetchData();
  }, [token]);

  return null; // No renderizas nada ya que rediriges.
};

export default Root;
